import {
  getUserListCombo,
  getUserList,
  saveUserAPI,
  deleteUserAPI,
  changePasswordAPI
} from '../../../services/Masters/MatersService';

export const fetchUsers = async () => {
  try {
    const response = await getUserList();

    if (response && response.success) {
      return response.returnResult || [];
    } else {
      window.showSnackbar({
        message: response?.message || 'An error occurred while fetching users list',
        variant: 'error'
      });
      console.log('Error fetching users list:', response?.message);
      return [];
    }
  } catch (err) {
    window.showSnackbar({
      message: err.message || 'An error occurred while fetching users list',
      variant: 'error'
    });
    console.log('Error fetching users list:', err);
    return [];
  }
};

export const fetchUsersCombo = async () => {
  try {
    const response = await getUserListCombo();

    if (response && response.success) {
      return response.returnResult || [];
    } else {
      window.showSnackbar({
        message: response?.message || 'An error occurred while fetching users list',
        variant: 'error'
      });
      console.log('Error fetching users list:', response?.message);
      return [];
    }
  } catch (err) {
    window.showSnackbar({
      message: err.message || 'An error occurred while fetching users list',
      variant: 'error'
    });
    console.log('Error fetching users list:', err);
    return [];
  }
};

export const saveUser = async (payload, customSuccessMsg, customErrorMsg) => {
  try {
    const response = await saveUserAPI(payload);
    if (!response || !response.success) {
      console.log('response?.message', response?.message || 'Failed to save user');
      window.showSnackbar({
        message: customErrorMsg || `Failed to save user`,
        variant: 'error'
      });
    } else {
      window.showSnackbar({
        message: customSuccessMsg || `User saved successfully`,
        variant: 'success'
      });
    }
    return response;
  } catch (err) {
    const errorMessage = err?.message || (typeof err === 'string' ? err : 'Failed to save user');
    window.showSnackbar({
      message: errorMessage,
      variant: 'error'
    });
    console.log('Failed to save user:', err);
    return { success: false, message: errorMessage };
  }
};

export const deleteUser = async (userGUID = '', customSuccessMsg, customErrorMsg) => {
  try {
    const response = await deleteUserAPI(userGUID);
    if (!response || !response.success) {
      console.log('response?.message', response?.message || 'Failed to delete software name');
      window.showSnackbar({
        message: customErrorMsg || `Failed to delete software name`,
        variant: 'error'
      });
    } else {
      window.showSnackbar({
        message: customSuccessMsg || `Software name deleted successfully`,
        variant: 'success'
      });
    }
    return response;
  } catch (err) {
    const errorMessage =
      err?.message || (typeof err === 'string' ? err : 'Failed to delete software name');
    window.showSnackbar({
      message: errorMessage,
      variant: 'error'
    });
    console.log('Failed to delete software name:', err);
    return { success: false, message: errorMessage };
  }
};

export const changePassword = async (payload, customSuccessMsg, customErrorMsg) => {
  try {
    const response = await changePasswordAPI(payload);
    if (!response || !response.success) {
      console.log('response?.message', response?.message || 'Failed to change password');
      window.showSnackbar({
        message: customErrorMsg || `Failed to change password`,
        variant: 'error'
      });
    } else {
      window.showSnackbar({
        message: customSuccessMsg || `Password changed successfully`,
        variant: 'success'
      });
    }
    return response;
  } catch (err) {
    const errorMessage = err?.message || (typeof err === 'string' ? err : 'Failed to change password');
    window.showSnackbar({
      message: errorMessage,
      variant: 'error'
    });
    console.log('Failed to change password:', err);
    return { success: false, message: errorMessage };
  }
};

